import React, { useState } from "react";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { FormControl, TextField } from "@mui/material";
import RemoveIcon from "../../../images/remove.png";
import PlusIcon from "../../../images/plus_icon.png";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Director from "./Director";

const DirectorAndCreatorDetails = ({
  formData,
  setFormData,
  errors,
  setDirectorCreatorErrors,
}) => {
  const [showCastAndCrewRemoveButton, setShowCastAndCrewRemoveButton] =
    useState(false);
  const [selectedDetailsCastCrewFile, setSelectedDetailsCastCrewFile] =
    useState(null);

  const [country, setCountry] = React.useState("");

  const handleselectedDetailsCastCrewFile = (event) => {
    setSelectedDetailsCastCrewFile(event.target.files[0]);
    setShowCastAndCrewRemoveButton(true);
    const DetailsCastCrewfile = event.target.files[0];
    // Do something with the uploadd file

    setFormData((prevState) => ({
      ...prevState,
      details_of_cast_crew: DetailsCastCrewfile,
      is_details_of_cast_crew: 1,
    }));
  };
  const handleCastAndCrewAttachClick = () => {
    setShowCastAndCrewRemoveButton(true);
  };

  const handleCastAndCrewRemoveClick = () => {
    setShowCastAndCrewRemoveButton(false);
    setSelectedDetailsCastCrewFile(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    errors[name] = "";
    setDirectorCreatorErrors(errors);
  };
  return (
    <>
      <h3>
        6. Director(s)/Creator(s) Details<span className="text-danger">*</span>
      </h3>
      {/* <p className='text-danger'>NOTE:</p> */}

      <form>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <h6>(a) Director(s) Details</h6>
              </Grid>

              <Director
                proms={{ type: 2 }}
                setFormDataMain={setFormData}
                errors={errors}
                setDirectorCreatorErrors={setDirectorCreatorErrors}
              />
            </Grid>

            <Grid container spacing={2} className="mt-4">
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <h6>(b) Creator(s) Details(if any)</h6>
              </Grid>

              <Director
                proms={{ type: 1 }}
                setFormDataMain={setFormData}
                errors={errors}
                setDirectorCreatorErrors={setDirectorCreatorErrors}
              />
            </Grid>

            <Grid container spacing={2} className="mt-2">
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <p className="text-danger">
                  NOTE: Name of the Director(s)/ Creator(s) will be credited as
                  declared in the application form. No request for the change of
                  name would be entertained at any stage.
                </p>
              </Grid>
            </Grid>

            <Grid container spacing={2} className="mt-4">
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <h3 className="text-capitalize">
                  7. Other Details<span style={{ color: "red" }}>*</span>
                </h3>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <Box>
                                    <textarea
                                        className="form-control text-area-class"
                                        placeholder="Story Writer"
                                        id="story_writer"
                                        style={{ height: '100px', borderRadius: '5px' }}
                                        name="story_writer"
                                        value={formData.story_writer || ''}
                                        onChange={handleChange}
                                    />
                                </Box> */}

                <Box>
                  <TextField
                    id="story_writer"
                    label="(i) Story writer"
                    multiline
                    fullWidth
                    // maxRows={4}
                    name="story_writer"
                    value={formData.story_writer || ""}
                    onChange={handleChange}
                  />
                  {errors.story_writer && (
                    <p className="text-danger">{errors.story_writer}</p>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <Box>
                                    <textarea
                                        className="form-control text-area-class"
                                        placeholder="Screenplay writer"
                                        id="screening_writer"
                                        style={{ height: '100px', borderRadius: '5px' }}
                                        name="screening_writer"
                                        value={formData.screening_writer || ''}
                                        onChange={handleChange}
                                    />
                                </Box> */}
                <Box>
                  <TextField
                    id="screening_writer"
                    label="(ii) Screenplay writer(s)"
                    multiline
                    fullWidth
                    // maxRows={4}
                    name="screening_writer"
                    value={formData.screening_writer || ""}
                    onChange={handleChange}
                  />
                </Box>
                {errors.screening_writer && (
                  <p className="text-danger">{errors.screening_writer}</p>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <Box>
                                    <textarea
                                        className="form-control text-area-class"
                                        placeholder="Director of photography"
                                        id="director_of_photography"
                                        style={{ height: '100px', borderRadius: '5px' }}
                                        name="director_of_photography"
                                        value={formData.director_of_photography || ''}
                                        onChange={handleChange}
                                    />

                                </Box> */}
                <Box>
                  <TextField
                    id="director_of_photography"
                    label="(iii) Director of Photography"
                    multiline
                    fullWidth
                    // maxRows={4}
                    name="director_of_photography"
                    value={formData.director_of_photography || ""}
                    onChange={handleChange}
                  />
                </Box>
                {errors.director_of_photography && (
                  <p className="text-danger">
                    {errors.director_of_photography}
                  </p>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <Box>
                                    <textarea
                                        className="form-control text-area-class"
                                        placeholder="Editor"
                                        id="editior"
                                        style={{ height: '100px', borderRadius: '5px' }}
                                        name="editior"
                                        value={formData.editior || ''}
                                        onChange={handleChange}
                                    />

                                </Box> */}
                <Box>
                  <TextField
                    id="editior"
                    label="(iv) Editor"
                    multiline
                    fullWidth
                    // maxRows={4}
                    name="editior"
                    value={formData.editior || ""}
                    onChange={handleChange}
                  />
                </Box>
                {errors.editior && (
                  <p className="text-danger">{errors.editior}</p>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <Box>
                                    <textarea
                                        className="form-control text-area-class"
                                        placeholder="Art Director"
                                        id="art_director"
                                        style={{ height: '100px', borderRadius: '5px' }}
                                        name="art_director"
                                        value={formData.art_director || ''}
                                        onChange={handleChange}
                                    />

                                </Box> */}
                <Box>
                  <TextField
                    id="art_director"
                    label="(v) Art Director"
                    multiline
                    fullWidth
                    // maxRows={4}
                    name="art_director"
                    value={formData.art_director || ""}
                    onChange={handleChange}
                  />
                </Box>
                {errors.art_director && (
                  <p className="text-danger">{errors.art_director}</p>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <Box>
                                    <textarea
                                        className="form-control text-area-class"
                                        placeholder="Costume Designer"
                                        id="costume_director"
                                        style={{ height: '100px', borderRadius: '5px' }}
                                        name="costume_director"
                                        value={formData.costume_director || ''}
                                        onChange={handleChange}
                                    />
                                </Box> */}
                <Box>
                  <TextField
                    id="costume_director"
                    label="(vi) Costume Designer"
                    multiline
                    fullWidth
                    // maxRows={4}
                    name="costume_director"
                    value={formData.costume_director || ""}
                    onChange={handleChange}
                  />
                </Box>
                {errors.costume_director && (
                  <p className="text-danger">{errors.costume_director}</p>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <Box>
                                    <textarea
                                        className="form-control text-area-class"
                                        placeholder="Director of Music"
                                        id="music_director"
                                        style={{ height: '100px', borderRadius: '5px' }}
                                        name="music_director"
                                        value={formData.music_director || ''}
                                        onChange={handleChange}
                                    />
                                </Box> */}
                <Box>
                  <TextField
                    id="music_director"
                    label="(vii) Director of Music"
                    multiline
                    fullWidth
                    // maxRows={4}
                    name="music_director"
                    value={formData.music_director || ""}
                    onChange={handleChange}
                  />
                </Box>
                {errors.music_director && (
                  <p className="text-danger">{errors.music_director}</p>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <Box>
                                    <textarea
                                        className="form-control text-area-class"
                                        placeholder="Sound Designer"
                                        id="sound_designer"
                                        style={{ height: '100px', borderRadius: '5px' }}
                                        name="sound_designer"
                                        value={formData.sound_designer || ''}
                                        onChange={handleChange}
                                    />
                                </Box> */}
                <Box>
                  <TextField
                    id="sound_designer"
                    label="(viii) Sound Designer"
                    multiline
                    fullWidth
                    // maxRows={4}
                    name="sound_designer"
                    value={formData.sound_designer || ""}
                    onChange={handleChange}
                  />
                </Box>
                {errors.sound_designer && (
                  <p className="text-danger">{errors.sound_designer}</p>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <Box>
                                    <textarea
                                        className="form-control text-area-class"
                                        placeholder="Principal cast"
                                        id="sound_designer"
                                        style={{ height: '100px', borderRadius: '5px' }}
                                        name="principal_cast"
                                        value={formData.principal_cast || ''}
                                        onChange={handleChange}
                                    />
                                </Box> */}
                <Box>
                  <TextField
                    id="sound_designer"
                    label="(ix) Principal Cast"
                    multiline
                    fullWidth
                    // maxRows={4}
                    name="principal_cast"
                    value={formData.principal_cast || ""}
                    onChange={handleChange}
                  />
                </Box>
                {errors.principal_cast && (
                  <p className="text-danger">{errors.principal_cast}</p>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default DirectorAndCreatorDetails;
